<section class="accordion" [ngClass]="'accordion___' + theme()">
  <div class="accordion__container">
    @for (item of renderedItems; track item.id) {
      <div class="accordion__item">
        <div
          class="accordion__header"
          (click)="toggle(item.id)"
          [class.accordion__header___noBorder]="expanded.has(item.id)"
        >
          <ng-container
            [ngTemplateOutlet]="item.header()?.templateRef || null"
            [ngTemplateOutletContext]="generateContext(item)"
          />
          <img
            class="accordion__icon"
            [@headerIconToggle]="expanded.has(item.id) ? 'expanded' : 'collapsed'"
            [src]="getIconSrc()"
            alt=""
          />
        </div>
        <div
          class="accordion__content"
          [@contentExpansion]="expanded.has(item.id) ? 'expanded' : 'collapsed'"
        >
          <ng-container *ngTemplateOutlet="item.content()?.templateRef || null" />
        </div>
      </div>
    }
  </div>
</section>
